import { twMerge } from 'tailwind-merge';

const EducatorProfilePicture = ({ id='', url, fullName='' }) => {

  const hashValue = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const gradientIndex = (hashValue % 10) + 1

  const initial = fullName.split(' ')[1][0]

  return (
    <>
      <div className={'w-6 h-6 overflow-hidden'}>
        <Choose>
          <When condition={url}>
            <img src={url} alt='profile' className='w-full h-full object-cover rounded-full' />
          </When>
          <Otherwise>
            <div className={`w-full h-full flex flex-row items-center justify-center rounded-full relative`}>
              <div className='text-sm h-4 text-white relative z-10'>{initial}</div>
              <img src={`/gradients/${gradientIndex}-small.png`} className='w-full h-full object-cover rounded-full absolute top-0' />
            </div>
          </Otherwise>
        </Choose>
      </div>
    </>
  )
}

export default EducatorProfilePicture
